module.exports = __webpack_public_path__ + "static/img/packBack4.839c091.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packBack4.jpg
// module id = Y63J
// module chunks = 0